// The one place the SPA decides which timezone a date is rendered in.
//
// WHY THIS EXISTS. Seven call sites across the print sheets, the load pages
// and the dispatch board formatted times through a hardcoded
// `moment(t).tz('America/Los_Angeles')`, in a product sold to carriers who are
// not all in California — a Denver dispatcher's paperwork said the truck left
// an hour before it did. `org.timezone` is now a registered tenant setting
// (api/app/Services/tenantSettings.js, group Organization), so those sites ask
// this module instead and a tenant answers for itself.
//
// WHY A FALLBACK OF America/Los_Angeles RATHER THAN THE BROWSER'S ZONE. It is
// what every one of those call sites did before the setting existed, and it is
// also the registry's default, so a tenant who has never opened Preferences
// sees exactly what they saw yesterday. The window it covers is small — the
// organization is fetched at boot, without an await (main.js) — but it is real,
// and a sheet that prints in the browser's zone for the first second and the
// org's zone afterwards would be worse than one that is simply consistent.

import { orgSetting } from './orgSettings.js';

/**
 * What the seven call sites used before `org.timezone` existed, and what the
 * registry registers as the setting's default. Exported so a test can name it
 * rather than repeat the string.
 */
export const FALLBACK_ZONE = 'America/Los_Angeles';

/**
 * orgZone(store) -> an IANA zone name, always.
 *
 * `store` is the Vuex store: `this.$store` in a component, or the module the
 * print sheets already `require()` for the carrier's legal name. Falls back
 * whenever the organization has not arrived (or its fetch failed), and also
 * when the value is not a non-empty string, because a blank zone name would
 * make `moment.tz()` fall through to UTC with only a console warning.
 */
export function orgZone(store) {
  const zone = orgSetting(store, 'org.timezone', FALLBACK_ZONE);
  return typeof zone === 'string' && zone !== '' ? zone : FALLBACK_ZONE;
}
